
const user = JSON.parse(localStorage.getItem('profile'))

export const initialState = {
    selling: [],
    payable:[],
    total: 0,
    paymentMode:'',
    pax:0,
    // notes: user?.userProfile?.paymentDetails,
    // rates: '',
    // vat: 0,
    // currency: '',
    // invoiceNumber is assigned by the backend when the invoice is created.
    invoiceNumber: '',
    // status: '',
    creator: '',
}
